import { combineReducers } from 'redux'

import made from './made'
import received from './received'

export default combineReducers({
  made,
  received
})
